var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9063 0.27921L1.03134 10.5874C-0.44679 11.4425 -0.304993 13.6296 1.27626 14.2784L6.18759 16.3109V19.9374C6.18759 21.9312 8.73134 22.7519 9.90868 21.1663L11.7907 18.6269L16.5989 20.612C16.8524 20.7151 17.1188 20.7667 17.3853 20.7667C17.7376 20.7667 18.0856 20.6765 18.3993 20.5003C18.9493 20.1909 19.3274 19.6409 19.4263 19.0179L21.9786 2.38038C22.2407 0.657335 20.3931 -0.575868 18.9063 0.27921ZM8.25009 19.9374V17.1616L9.82275 17.8105L8.25009 19.9374ZM17.3853 18.7042L10.7767 15.9757L16.8009 7.28312C17.2606 6.6171 16.3927 5.84366 15.7825 6.37218L6.69462 14.2913L2.06259 12.3749L19.9376 2.06241L17.3853 18.7042Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.0e1732b956af7edc1fdb0c1fd3edede5.svg";
export { ForwardRef as ReactComponent };